/**
 * ref : https://stackoverflow.com/questions/3234256/find-mouse-position-relative-to-element
 * @param {HTMLElement} targetDom
 * @param {MouseEvent} mouseEvent
 */
export function getRelativeXY(targetDom, mouseEvent) {
  const rect = targetDom.getBoundingClientRect();
  const x = mouseEvent.pageX - rect.left;
  const y = mouseEvent.clientY - rect.top; //FIXME: still has bug. y position is incorrect.
  return { x, y };
}

/**
 * @param {HTMLElement} targetDom
 */
export function getWidth(targetDom) {
  //FIXME: getDomWidth is better.
  return targetDom.offsetWidth;
}

/**
 * @param {HTMLElement} targetDom
 */
export function getHeight(targetDom) {
  return targetDom.offsetHeight;
}

/**
 * @param {HTMLElement} targetDom
 */
export function getWH(targetDom) {
  return { width: targetDom.offsetWidth, height: targetDom.offsetHeight };
}

export function setWidth(dom, width) {
  dom.style.width = `${width}px`;
}

export function setHeight(dom, height) {
  dom.style.height = `${height}px`;
}

// This function will help. Not to stretch using set to height fixed.
// Dom height may be 100% at initial. but after excutes this function.
// Dom height will be changed with fixed pixel.
export function preventStretchHeight(dom) {
  const height = dom.offsetHeight;
  dom.style.height = `${height}px`;
}

export function loadBlobToImageElem(blob, imageElem, { width = 300, height = 300 }) {
  // blob to data url
  const url = URL.createObjectURL(blob);

  // data url to image elem
  imageElem.width = width;
  imageElem.height = height;
  imageElem.addEventListener("load", () => URL.revokeObjectURL(url), {
    once: true,
  });
  imageElem.src = url;
}

export function setStyle(el, spec) {
  for (var n in spec) {
    el.style[n] = spec[n];
  }
}
